import { ChipotleUOnboardingPageLoadEvent } from "@/services/analytics/events/chipotle-u-onboarding-page-load"; 
import { AdobeBaseEvent } from './adobe-base-event';
import { AnalyticsEventType } from '../models';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';

export class AdobeChipotleUOnboardingPageLoadEvent extends AdobeBaseEvent {
    name = 'AdobeChipotleUOnboardingPageLoadEvent';
    event = AnalyticsEventType.PageLoaded;

    constructor(
        event: ChipotleUOnboardingPageLoadEvent,
        store: Store<AppState>, 
        services: ServicesContainer
    ) {
        super(store, services);

        this.web.webPageDetails = {
            language: "en-us",
            pageType: "modal",
            pageViews: { value: 1 },
            siteRegion: "US",
            siteSection: "rewards"
        }

        switch (event.slideNumber) {
            case 1:
                this.web.webPageDetails.name = "rewards:exchange:onboarding-1-greeting";
                break;
            case 2:
                this.web.webPageDetails.name = "rewards:exchange:onboarding-2-journey";
                break;
            case 3:
                this.web.webPageDetails.name = "rewards:exchange:onboarding-3-benefits";
                break;
            case 4:
                this.web.webPageDetails.name = "rewards:exchange:onboarding-4-app-promo";
                break;
            default:
                break;
        }
    }
}